// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaintMartin from '../_raw/flag/icon_flag_saint_martin.png';

export default () => <img src={SaintMartin} alt="SaintMartin" />;
